module.exports = __webpack_public_path__ + "media/1.2c6de69c.mp3";